export enum MessageDeletionType {
    SingleDelete = 0,
    MultipleDelete = 1
}